/**
 * Page shown to authenticated users whose accounts have been blocked.
 * Provides a clear message and options to log out or visit the public site.
 *
 * Called by:
 * - App.tsx as standalone route at /blocked
 */
import { Button, Result, Space } from 'antd';
import { StopOutlined, LogoutOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function BlockedPage() {
  const { user, logout, isAuthenticated, isBlocked } = useAuth();
  const navigate = useNavigate();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    navigate('/login', { replace: true });
    return null;
  }

  // If not blocked, redirect to reviewer portal
  if (!isBlocked) {
    navigate('/reviewer', { replace: true });
    return null;
  }

  async function handleLogout() {
    await logout();
    navigate('/');
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#0a0a0f',
        padding: '24px',
      }}
    >
      <Result
        icon={<StopOutlined style={{ color: '#ff4d4f' }} />}
        title={<span style={{ color: '#f5f5f5' }}>Account Blocked</span>}
        subTitle={
          <span style={{ color: '#a0a0a0' }}>
            Hi {user?.name || 'there'}, your account has been blocked from commenting.
            If you believe this is a mistake, please contact the administrator.
            You can still browse the public site.
          </span>
        }
        extra={
          <Space>
            <Button
              type="primary"
              icon={<HomeOutlined />}
              onClick={() => navigate('/home')}
            >
              Visit Public Site
            </Button>
            <Button
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            >
              Log Out
            </Button>
          </Space>
        }
      />
    </div>
  );
}

export default BlockedPage;
